import { z } from 'zod';
export const PASSWORD_SCHEMA = z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@{}<>()/:;_=+,.$%^&*-]).{8,}$/, 'Add an uppercase, lowercase, number and symbol');
